var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar24(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_50_Kids_Icons-31",
    "data-name": "50_Kids_Icons-31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z",
    fill: "#704d70"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4597",
    "data-name": "Group 4597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4596",
    "data-name": "Group 4596"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4581",
    "data-name": "Group 4581",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M95.759,424.258l4.889-.7,5.064,17.986-12.6-.873Z",
    transform: "translate(-78.566 -357.379)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4580",
    "data-name": "Group 4580",
    transform: "translate(14.046 20.774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4572",
    "data-name": "Group 4572",
    transform: "translate(7.519)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_121",
    "data-name": "Ellipse 121",
    cx: 4.548,
    cy: 3.898,
    rx: 4.548,
    ry: 3.898,
    transform: "translate(0 8.615) rotate(-71.272)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_122",
    "data-name": "Ellipse 122",
    cx: 4.548,
    cy: 3.898,
    rx: 4.548,
    ry: 3.898,
    transform: "translate(3.453 11.92) rotate(-71.272)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4573",
    "data-name": "Group 4573",
    transform: "translate(3.614 5.675)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_123",
    "data-name": "Ellipse 123",
    cx: 4.387,
    cy: 3.76,
    rx: 4.387,
    ry: 3.76,
    transform: "translate(0 8.31) rotate(-71.272)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_124",
    "data-name": "Ellipse 124",
    cx: 4.387,
    cy: 3.76,
    rx: 4.387,
    ry: 3.76,
    transform: "translate(3.331 11.498) rotate(-71.272)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4574",
    "data-name": "Group 4574",
    transform: "translate(1.288 12.622)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_125",
    "data-name": "Ellipse 125",
    cx: 4.226,
    cy: 3.622,
    rx: 4.226,
    ry: 3.622,
    transform: "translate(0 8.004) rotate(-71.272)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_126",
    "data-name": "Ellipse 126",
    cx: 4.226,
    cy: 3.622,
    rx: 4.226,
    ry: 3.622,
    transform: "translate(3.209 11.075) rotate(-71.272)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4575",
    "data-name": "Group 4575",
    transform: "translate(0.198 20.074)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_127",
    "data-name": "Ellipse 127",
    cx: 4.064,
    cy: 3.484,
    rx: 4.064,
    ry: 3.484,
    transform: "translate(0 7.699) rotate(-71.272)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_128",
    "data-name": "Ellipse 128",
    cx: 4.064,
    cy: 3.484,
    rx: 4.064,
    ry: 3.484,
    transform: "translate(3.086 10.652) rotate(-71.272)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4576",
    "data-name": "Group 4576",
    transform: "translate(0 27.262)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_129",
    "data-name": "Ellipse 129",
    cx: 3.903,
    cy: 3.346,
    rx: 3.903,
    ry: 3.346,
    transform: "translate(0 7.393) rotate(-71.272)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_130",
    "data-name": "Ellipse 130",
    cx: 3.903,
    cy: 3.346,
    rx: 3.903,
    ry: 3.346,
    transform: "translate(2.964 10.23) rotate(-71.272)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4577",
    "data-name": "Group 4577",
    transform: "translate(0.353 33.42)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_131",
    "data-name": "Ellipse 131",
    cx: 3.742,
    cy: 3.207,
    rx: 3.742,
    ry: 3.207,
    transform: "translate(0 7.088) rotate(-71.272)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_132",
    "data-name": "Ellipse 132",
    cx: 3.742,
    cy: 3.207,
    rx: 3.742,
    ry: 3.207,
    transform: "translate(2.841 9.807) rotate(-71.272)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4578",
    "data-name": "Group 4578",
    transform: "translate(0.913 37.779)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_133",
    "data-name": "Ellipse 133",
    cx: 3.581,
    cy: 3.069,
    rx: 3.581,
    ry: 3.069,
    transform: "translate(0 6.783) rotate(-71.272)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_134",
    "data-name": "Ellipse 134",
    cx: 3.581,
    cy: 3.069,
    rx: 3.581,
    ry: 3.069,
    transform: "translate(2.719 9.385) rotate(-71.272)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4579",
    "data-name": "Group 4579",
    transform: "translate(1.338 39.574)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_135",
    "data-name": "Ellipse 135",
    cx: 3.42,
    cy: 2.931,
    rx: 3.42,
    ry: 2.931,
    transform: "translate(0 6.477) rotate(-71.272)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_136",
    "data-name": "Ellipse 136",
    cx: 3.42,
    cy: 2.931,
    rx: 3.42,
    ry: 2.931,
    transform: "translate(2.597 8.962) rotate(-71.272)",
    fill: "#3d2a3d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4582",
    "data-name": "Group 4582",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M146.595,217.31c1.125,2.664.512,5.254-1.368,5.784s-4.317-1.2-5.442-3.864-.512-5.254,1.368-5.784S145.47,214.646,146.595,217.31Z",
    transform: "translate(-117.468 -180.015)",
    fill: "#e38a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M329.931,217.31c-1.125,2.664-.512,5.254,1.368,5.784s4.317-1.2,5.441-3.864.513-5.254-1.368-5.784S331.056,214.646,329.931,217.31Z",
    transform: "translate(-277.904 -180.014)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4583",
    "data-name": "Group 4583",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M119.654,399.234l-.009-.144c0-8.781-3.287-17.288-7.3-18.908L95.252,373.3a22.645,22.645,0,0,0-14.6-.019L63.313,380.2c-4.017,1.608-7.3,10.106-7.3,18.886l-.009.144Z",
    transform: "translate(-47.25 -313.94)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4584",
    "data-name": "Group 4584",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M227.843,250.8a6.825,6.825,0,0,1-6.825,6.825h-.828a6.825,6.825,0,0,1-6.825-6.825V233.22a6.825,6.825,0,0,1,6.825-6.825h.828a6.825,6.825,0,0,1,6.825,6.825Z",
    transform: "translate(-180.028 -191.021)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4586",
    "data-name": "Group 4586",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4585",
    "data-name": "Group 4585",
    transform: "translate(25.889 11.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M195.067,100.877a14.688,14.688,0,0,1-14.688,14.688h0a14.688,14.688,0,0,1-14.688-14.688V88.66a14.688,14.688,0,0,1,14.688-14.688h0A14.688,14.688,0,0,1,195.067,88.66v12.217Z",
    transform: "translate(-165.691 -73.972)",
    fill: "#f5b68c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4587",
    "data-name": "Group 4587",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_137",
    "data-name": "Ellipse 137",
    cx: 1.698,
    cy: 1.698,
    r: 1.698,
    transform: "translate(33.247 35.598)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_138",
    "data-name": "Ellipse 138",
    cx: 1.698,
    cy: 1.698,
    r: 1.698,
    transform: "translate(44.51 35.598)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4588",
    "data-name": "Group 4588",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M166.584,69.792c-9.523,0-17.242,8.367-17.242,18.689a19.809,19.809,0,0,0,2.338,9.4l.565-4.794a11.025,11.025,0,0,1,10.949-9.734h6.778a11.025,11.025,0,0,1,10.95,9.732l.567,4.8a19.81,19.81,0,0,0,2.338-9.4C183.827,78.159,176.107,69.792,166.584,69.792Z",
    transform: "translate(-126.007 -58.887)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4589",
    "data-name": "Group 4589",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M247,253.581a2.616,2.616,0,0,1-5.106.591,2.768,2.768,0,0,0-.125.78,2.8,2.8,0,1,0,5.6,0A2.765,2.765,0,0,0,247,253.581Z",
    transform: "translate(-203.989 -213.959)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4590",
    "data-name": "Group 4590",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M119.645,413.291c0-8.781-3.287-17.288-7.3-18.908l-13.591-5.475a12,12,0,0,1-21.828.058L63.313,394.4c-4.017,1.608-7.3,10.106-7.3,18.886l-.009.144h63.654Z",
    transform: "translate(-47.25 -328.141)",
    fill: "#ffc34a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4591",
    "data-name": "Group 4591",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_139",
    "data-name": "Ellipse 139",
    cx: 3.43,
    cy: 2.572,
    rx: 3.43,
    ry: 2.572,
    transform: "translate(46.579 38.995)",
    fill: "#eb987f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_140",
    "data-name": "Ellipse 140",
    cx: 3.43,
    cy: 2.572,
    rx: 3.43,
    ry: 2.572,
    transform: "translate(27.716 38.995)",
    fill: "#eb987f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4592",
    "data-name": "Group 4592",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    d: "M232.218,287.411a5.359,5.359,0,0,1-7.119,0c-1.351-1.272-3.392.761-2.037,2.037a8.3,8.3,0,0,0,11.193,0c1.355-1.276-.686-3.309-2.037-2.037Z",
    transform: "translate(-187.832 -242.163)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4595",
    "data-name": "Group 4595",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4593",
    "data-name": "Group 4593",
    transform: "translate(31.697 32.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    d: "M203.709,208.108a4.644,4.644,0,0,1,3.443-1.435.5.5,0,0,0,0-1.005A5.654,5.654,0,0,0,203,207.4c-.435.479.274,1.192.711.711Z",
    transform: "translate(-202.862 -205.668)",
    fill: "#735a73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4594",
    "data-name": "Group 4594",
    transform: "translate(44.069 32.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    d: "M286.683,207.4a5.653,5.653,0,0,0-4.154-1.729.5.5,0,0,0,0,1.005,4.643,4.643,0,0,1,3.443,1.435c.437.481,1.146-.233.711-.711Z",
    transform: "translate(-282.044 -205.669)",
    fill: "#735a73"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar24);
export default __webpack_public_path__ + "static/media/avatar24.ae27ab2dc0d21e585b90529a61c325b6.svg";
export { ForwardRef as ReactComponent };